import { render, staticRenderFns } from "./ComponentAlert.vue?vue&type=template&id=859073c0"
import script from "./ComponentAlert.vue?vue&type=script&lang=js"
export * from "./ComponentAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports